import { render, staticRenderFns } from "./NewsIns.vue?vue&type=template&id=2e2d7444&scoped=true"
import script from "./NewsIns.vue?vue&type=script&lang=js"
export * from "./NewsIns.vue?vue&type=script&lang=js"
import style0 from "./NewsIns.vue?vue&type=style&index=0&id=2e2d7444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2d7444",
  null
  
)

export default component.exports